import React, { FC } from 'react'

export const SettingsAdditionalPluginView: FC<IGridProps> = (props) => {
    return (
        <>
        </>
    )
}